export const RETAIL_META_DESCRIPTION =
  "Media monitoring and media analysis for retail across Southeast Europe - promotions, store openings, reputation analysis and competitive intelligence.";
